import type {
  ProductAccessoriesPagedResult,
  ProductAccessoryCategoryPagedResult,
  ProductAccessorySetsMinimalPagedResult,
  QueryParams,
} from '~/types/api'

export function createAccessoriesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'product-accessories'
  const DOMAIN_PRODUCT_LINES = 'product-lines'
  const DOMAIN_PRODUCT_SET = 'product-sets'
  const DOMAIN_CATEGORIES = 'product-accessory-categories'
  const DOMAIN_PUBLIC_ACCESSORY_SETS = 'public-accessory-sets'
  const DOMAIN_PUBLIC_ACCESSORIES = 'public-accessories'

  async function getAll(params?: QueryParams) {
    return get<ProductAccessoriesPagedResult>([DOMAIN], {
      params,
    })
  }

  async function getAllAccessorySetsByLine(
    lineId: number,
    params?: QueryParams
  ) {
    return get<ProductAccessorySetsMinimalPagedResult>(
      [DOMAIN_PRODUCT_LINES, lineId.toString(), DOMAIN_PUBLIC_ACCESSORY_SETS],
      { params }
    )
  }

  async function getAllAccessoriesByLine(lineId: number, params?: QueryParams) {
    return get<ProductAccessoriesPagedResult>(
      [DOMAIN_PRODUCT_LINES, lineId.toString(), DOMAIN_PUBLIC_ACCESSORIES],
      { params }
    )
  }

  async function getAllAccessoryCategories(params?: QueryParams) {
    return get<ProductAccessoryCategoryPagedResult>([DOMAIN_CATEGORIES], {
      params,
    })
  }

  async function getAllAccessoriesBySet(setId: number, params?: QueryParams) {
    return get<ProductAccessoriesPagedResult>(
      [DOMAIN_PRODUCT_SET, setId.toString(), DOMAIN_PUBLIC_ACCESSORIES],
      { params }
    )
  }

  return {
    getAll,
    getAllAccessorySetsByLine,
    getAllAccessoriesByLine,
    getAllAccessoryCategories,
    getAllAccessoriesBySet,
  }
}
